<template>
    <div>
        <div class="banner">
            <div class="left">
                <p class="h1">超棒的内容+运营</p>
                <div class="three">
                    <div class="cir">
                        <span>
                            早期短视频<br>内容从业者
                        </span>
                    </div>
                    <div class="cir">
                        <span>
                            首批官方认证<br>服务商
                        </span>
                    </div>
                    <div class="cir">
                        <span>
                            全球短视频<br>内容制造商
                        </span>
                    </div>
                </div>
            </div>
            <div class="right">
                <img src="@/assets/list.png" class="list">
            </div>
        </div>
        <div class="main">
            <div class="container">
				<div class="row align-items-center">
					<div class="col-md-6">
						<div class="heading">专业内容制作</div>
						<p class="h1">您的短片<br>由影视级的拍摄制作团队搞定</p>
						<p class="desc">前期拍摄阶段：影视级拍摄团队，专业导演摄像导播配备，全程跟场视频拍摄制作，演唱会综艺活动现场直播；后期制作阶段：通过3D建模、动画，动作捕捉影像合成，AR滤镜及AI智能等特效方式，加工成极具表现力的视频。</p>
					</div>
                    <div class="col-md-6">
						<img src="@/assets/home_desc_1.png" class="img-fluid ori">
                        <img src="@/assets/home_desc_1.png" class="abi">
					</div>
				</div>
				<div class="row align-items-center">
					<div class="col-md-6">
						<div class="heading">前沿内容技术</div>
						<p class="h1">第二代<br>全新3D虚拟技术，更动感</p>
						<p class="desc">基于动作捕捉、表情捕捉技术，结合实时渲染、语音控制等系统进行集成，可以将真人演员的动作、表情、语音实时映射到虚拟角色身上。高度集成，并且实现全图形化界面操作，支持多人同时捕捉，满足不同IP和主题需求。</p>
					</div>
				</div>
                <div class="row align-items-center">
                    <div class="col-md-6">
						<div class="heading">数据中台运营</div>
						<p class="h1">数据化结构内容爆发全过程</p>
						<p class="desc">星斗大数据智能平台可以帮助我们在短视频社媒平台的内容创意过程中分析平台、判断热点、了解用户。更好的完成内容定位参考、辅助创意创作、粉丝数据分析、多平台内容发布、获取多流量、高效全面管理账号。</p>
					</div>
					<div class="col-md-6">
						<img src="@/assets/ad_14.jpg" class="img-fluid">
					</div>
				</div>
                <div class="row align-items-center">
                    <div class="col-md-6">
						<div class="heading">平台和内容运营</div>
						<p class="h1">更了解算法<br>才能把握分寸</p>
						<p class="desc">作为各平台官方认证的MCN机构和全效服务商，更全面的了解平台玩法规则和活动，更深入的研究平台内容裂变算法和推荐机制，更详实的全平台内容运营实操和方法累积，从而轻松获取逐级优质流量。</p>
					</div>
					<div class="col-md-6">
						<img src="@/assets/ad_15.jpg" class="img-fluid">
					</div>
				</div>
                <div class="row align-items-center">
                    <div class="col-md-6">
						<div class="heading">成功的内容和运营</div>
						<p class="h1">孕育爆款内容的成功经验<br>让我们离下一个爆款更近</p>
						<p class="link"><a href="javascript:void(0);" @click="$router.push('/cases')">获悉更多案例</a><img src="@/assets/arrow_right.jpg" alt=""></p>
					</div>
					<div class="col-md-6">
						<img src="@/assets/ad_16.jpg" class="img-fluid">
					</div>
				</div>
            </div>
        </div>
        <appoint/>
    </div>
</template>

<script>
import Appoint from '@/components/Appoint'
export default {
    components: {
        Appoint
    },
}
</script>

<style lang="stylus" scoped>
.abi
    position absolute
    width 120%

    @media screen and (max-width: 768px)
        display none

.ori
    display none 

    @media screen and (max-width: 768px)
        display block

.f-text
    display block
    width 200px
    text-align center
    white-space nowrap
    margin 24px 0

.banner
    position relative
    display flex
    flex-wrap wrap
    align-items center
    justify-content space-between
    max-width 1980px
    height 661px
    background-image url('../assets/banner_3.jpg')
    background-position top left
    background-repeat no-repeat
    margin 0 auto
    color #fff
    padding 10px 200px 0 300px 

    @media screen and (max-width: 1750px)
        padding 10px 150px 0 200px 

    @media screen and (max-width: 1600px)
        padding 10px 100px 0 150px 

    @media screen and (max-width: 1460px)
        padding 10px 50px 0 100px 

    @media screen and (max-width: 992px)
        padding 0 30px 0 70px 

    @media screen and (max-width: 920px)
        padding 0 30px 0 70px

    @media screen and (max-width: 807px)
        justify-content center
        padding 20px 0 0 0 

    .left

        .h1
            letter-spacing 3px
            font-size 80px

            @media screen and (max-width: 1360px)
                font-size 70px

            @media screen and (max-width: 1150px)
                font-size 50px

            @media screen and (max-width: 920px)
                font-size 46px
                letter-spacing 1px

            @media screen and (max-width: 450px)
                font-size 34px
                letter-spacing 0

        .three
            display flex

            .cir
                display flex
                justify-content center
                align-items center
                flex-shrink 0
                width 150px
                height 150px
                background url('../assets/circle.jpg') no-repeat 
                background-size contain
                text-align center
                margin 60px 100px 0 0

                @media screen and (max-width: 1360px)
                    width 140px
                    height 140px
                    margin 30px 50px 0 0
                    font-size 14px

                @media screen and (max-width: 1150px)
                    width 120px
                    height 120px
                    margin 30px 30px 0 0
                    font-size 14px

                @media screen and (max-width: 920px)
                    width 100px
                    height 100px
                    margin 30px 30px 0 0
                    font-size 12px

                @media screen and (max-width: 450px)
                    width 80px
                    height 80px
                    margin 20px 15px 0 0
                    font-size 10px

    .right

        .list
            @media screen and (max-width: 1360px)
                width 350px

            @media screen and (max-width: 920px)
                width 300px

.main
	.row
		margin 100px 0

		@media screen and (max-width: 992px)
			margin 50px 0

		.img-fluid
			margin-bottom 20px

		.heading
			color #9e9e9e
			font-size 22px

			@media screen and (max-width: 992px)
				font-size 18px

			&:before
				content '.'
				color #F44336
				width 5px
				border-radius 15px
				background #F44336
				margin-right 8px

		.h1
			color #424242
			font-size 40px
			margin 30px 0

			@media screen and (max-width: 992px)
				font-size 27px
				margin 10px 0

		.desc
			color #9e9e9e

			@media screen and (max-width: 992px)
				font-size 14px

		.link
			display flex
			align-items center

			a
				color #F44336
				margin-right 5px
			
			img
				height 18px

		.to-top
			@media screen and (max-width: 768px)
				order: 0
</style>